import React from 'react';
import EnhancedMarkdown from '@resources/js/components/EnhancedMarkdown/EnhancedMarkdown';
import VerticalContent from '@resources/js/components/VerticalContent/VerticalContent';
import convertImageUrlToOptimizedImageUrl from '../../../../archon/helpers/convertImageUrlToOptimizedImageUrl';

export type BuildsPartneredGuideSectionViewModel = {
  title: string;
  description: string;
  bannerUrl: string;
  bannerLabel: string;
  backgroundOneImageUrl: string;
  backgroundTwoImageUrl: string;
};

export default function BuildsPartneredGuideSection({
  title,
  description,
  bannerUrl,
  bannerLabel,
  backgroundOneImageUrl,
  backgroundTwoImageUrl,
}: BuildsPartneredGuideSectionViewModel): JSX.Element {
  const optimizedBackgroundOneImageUrl = convertImageUrlToOptimizedImageUrl(
    backgroundOneImageUrl,
    256,
    75,
    false
  );

  const optimizedBackgroundTwoImageUrl = convertImageUrlToOptimizedImageUrl(
    backgroundTwoImageUrl,
    1080,
    75,
    false
  );

  return (
    <VerticalContent className={'builds-partnered-guide-section'}>
      {' '}
      <EnhancedMarkdown
        markdown={`
# ${title}

${description}
`}
      />
      {/* eslint-disable-next-line react/jsx-no-target-blank */}
      <a href={bannerUrl} target={'_blank'}>
        <div className={'builds-partnered-guide-section__banner'}>
          <div
            className={'builds-partnered-guide-section__banner-bg-1'}
            style={{
              backgroundImage: `url(${optimizedBackgroundOneImageUrl})`,
            }}
          ></div>
          <div
            className={'builds-partnered-guide-section__banner-bg-2'}
            style={{
              backgroundImage: `url(${optimizedBackgroundTwoImageUrl})`,
            }}
          ></div>
          <div className={'builds-partnered-guide-section__banner-content'}>
            {bannerLabel}
          </div>
        </div>
      </a>
    </VerticalContent>
  );
}
